// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfp_a"};